import { memo, useCallback } from 'react'
import { useUserContext } from 'app/services/UserProvider/UserProvider'
import Button from 'components/core/Button/Button'
import Layout from 'components/core/Layout/Layout'
import { useModalContext } from 'components/interface/Modal/provider/ModalProvider'
import styles from './PromptNoAccess.module.scss'

/**
 * The `PromptNoAccess`
 *
 * @returns {React.ReactElement} the element
 */
function PromptNoAccess () {
  const { showModal } = useModalContext()
  const { logoutUser } = useUserContext()
  /**
   * Handle click newsletter
   */
  const handleClickNewsletter = useCallback(() => {
    showModal({
      id: 'app:newsletter'
    })
  }, [])

  /**
   * Handle click logout user
   */
  const handleClickDisconnectWallet = useCallback(
    e => {
      e.preventDefault()
      e.stopPropagation()

      logoutUser()
    },
    [logoutUser]
  )

  return (
    <>
      <Layout.Body align="center">
        <p>
          To access at this time,{' '}
          <strong className="text-gradient color-a">you need a passport</strong>
          . Passports can be obtained from the secondary market on Rarible.
        </p>
        <div className={styles.options}>
          <Button
            Tag="a"
            size="large"
            icon="rarible"
            href="https://rarible.com/metropolisworldpassportofficial/items"
            target="_blank"
            useHighlight={true}
          >
            View Passports on Rarible
          </Button>
          <Button
            size="large"
            color="c"
            icon="newsletter"
            onClick={handleClickNewsletter}
          >
            Sign up to our Newsletter
          </Button>
        </div>
        <div className={styles.disconnect}>
          <button
            className={styles.button}
            onClick={handleClickDisconnectWallet}
          >
            Disconnect Wallet
          </button>
        </div>
      </Layout.Body>
    </>
  )
}

export default memo(PromptNoAccess)
